<template>
  <g>
    <svg
      v-if="getSize().w"
      :width="getSize().w"
      :height="getSize().h"
      :x="getMin().x"
      :y="getMin().y"
    >
      <path
        v-if="+type === 1"
        class="line-hidden goto-line"
        :d="computedPathD"
        :stroke-width="6 * strokeWidth"
        :data-index="index"
      />
      <path
        :class="getClassName()"
        :d="computedPathD"
        :stroke-width="strokeWidth"
        :data-index="index"
      />
    </svg>
    <svg
      v-else
      :width="strokeWidth * 3"
      :height="getSize().h"
      :x="getMin().x - strokeWidth"
      :y="getMin().y"
    >
      <line
        :class="getClassName()"
        :x1="strokeWidth"
        :y1="y1 ? y1 : 1"
        :x2="strokeWidth"
        :y2="getSize().h"
        :stroke-width="strokeWidth"
        :data-index="index"
      />
    </svg>
  </g>
</template>

<script>
// import * as d3 from 'd3'

export default {
  name: 'CustomSpline',
  props: [
    'sx',
    'sy',
    'ex',
    'ey',
    'strokeColor',
    'type',
    'index',
    'y1'
  ],
  data: () => (
    {
      fontSize: 12,
      // strokeWidth: 1.2
      strokeWidth: 2
    }
  ),
  computed: {
    computedPathD() {
      const dirX = Math.sign(this.sx - this.ex)
      const dirY = Math.sign(this.sy - this.ey)
      const dir = this.getSize().h < this.getSize().w
      const ch = this.getSize().h / 2
      const cw = this.getSize().w / 2
      const r = Math.min(ch, cw)
      return `
        M${this.sx - this.getMin().x - dirX},${(this.sy - this.getMin().y)}
        q${-dirX * cw * !dir}, ${-dirY * ch * dir}
        ${-dirX * r}, ${-dirY * r}
        L${this.ex - this.getMin().x + dirX * r},${r}
        M${this.ex - this.getMin().x},${this.ey - this.getMin().y}
        q${dirX * cw * !dir}, ${dirY * ch * dir}
        ${dirX * r}, ${dirY * r}`
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {},
    getMin() {
      return {
        x: Math.min(this.sx, this.ex),
        y: Math.min(this.sy, this.ey)
      }
    },
    getSize() {
      return {
        w: Math.abs(this.sx - this.ex),
        h: Math.abs(this.sy - this.ey)
      }
    },
    getClassName() {
      switch (parseInt(this.type)) {
        case 1:
          return 'line-dot goto-line'
        default:
          return 'line-pain'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables";

svg path {
  fill: transparent;
  stroke: $stroke-line-color;
  pointer-events: stroke;
  /*stroke: #757575;*/
}

svg line {
  fill: transparent;
  stroke: $stroke-line-color;
  /*stroke: #757575;*/
}

.line {
  &-dot {
    stroke: $stroke-line-color;
    stroke-dasharray: 5,5;
  }

  &-dot:hover {
    stroke-width: 2px;
    stroke: #ff5722;
    cursor: pointer;
  }

  &-pain {
    /*stroke: $stroke-color;*/
    stroke: $stroke-line-color;
  }

  &-hidden {
    stroke: transparent;
    cursor: pointer;
  }

  &-hidden:hover + &-dot {
    stroke-width: 2px;
    stroke: #ff5722;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomSpline.vue